"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmployeeCardV2 = void 0;
const ac_1 = require("@app/ac");
const ui_1 = require("@app/component/ui");
const store_1 = require("@app/store");
const util_1 = require("@app/util");
const react_1 = __importDefault(require("react"));
const useChatDirectMessage_1 = require("@app/util/hooks/chat/useChatDirectMessage");
const useActivatePlugin_1 = require("@app/util/hooks/useActivatePlugin");
const use_modal_1 = require("@app/util/modal/use-modal");
require("./index.scss");
const employee_card_body_1 = require("./ui/employee-card-body");
const employee_card_footer_1 = require("./ui/employee-card-footer");
const employee_card_sidebar_1 = require("./ui/employee-card-sidebar");
const employee_card_context_1 = require("./util/employee-card-context");
const EmployeeCardV2 = ({ userId }) => {
    const dispatch = (0, store_1.useRootDispatch)();
    const { closeModal } = (0, use_modal_1.useModal)();
    const { startDirectMessage, canUseDirectMessage, canActivateChat } = (0, useChatDirectMessage_1.useChatDirectMessage)(userId);
    const { ActivatePlugin: ActivateChatPlugin } = (0, useActivatePlugin_1.useActivatePlugin)('chat');
    return (react_1.default.createElement(employee_card_context_1.EmployeeCardProvider, { userId: userId }, ({ isLoading }) => (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(ui_1.Modal, { testid: 'employee-card-modal', size: ui_1.Modal.SIZES.XL, extraHeaderButtons: [
                react_1.default.createElement("div", { key: `send-message-${userId}-0`, style: { marginRight: '0.5rem' } }, canActivateChat ? (react_1.default.createElement(ActivateChatPlugin, { key: 'activate-chat-0' })) : canUseDirectMessage ? (react_1.default.createElement(ui_1.Button, { style: 'BORDERLESS', onClick: async () => {
                        await dispatch((0, ac_1.setModal)(null));
                        await startDirectMessage();
                        closeModal();
                    }, ico: 'send' }, (0, util_1.t)('SEND_MESSAGE'))) : (false)),
            ], headerContent: react_1.default.createElement("div", { style: { display: 'flex', justifyContent: 'space-between' } },
                react_1.default.createElement(ui_1.Text, { text: (0, util_1.t)('EMPLOYEE_PROFILE_CARD_TITLE'), type: ui_1.Text.TYPES.BODY_LARGE, weight: ui_1.Text.WEIGHTS.BOLD })), footerContent: react_1.default.createElement(employee_card_footer_1.EmployeeCardFooter, null) },
            react_1.default.createElement("div", { className: 'ds-employee-card-v2' }, isLoading ? (react_1.default.createElement(ui_1.Loader, null)) : (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(employee_card_sidebar_1.EmployeeCardSidebar, null),
                react_1.default.createElement(employee_card_body_1.EmployeeCardBody, null)))))))));
};
exports.EmployeeCardV2 = EmployeeCardV2;
